import { render } from "./AffectedList.vue?vue&type=template&id=20ced92f"
import script from "./AffectedList.vue?vue&type=script&lang=js"
export * from "./AffectedList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__